import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';
import { radius } from '@shared/theme/shape';

import { ManageSectionTheme } from './ManageSection';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: 'fit-content',
      width: '100%',
    },
    header: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    headerClickable: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
      },
      '&:focus': {
        outline: '2px solid #0066CC',
        outlineOffset: '2px',
      },
    },
    headerContent: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerActions: {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(2),
    },
    title: {
      alignItems: 'center',
      color: colors.black.darker,
      display: 'flex',
      fontSize: 18,
      fontWeight: 500,
    },
    description: {
      fontWeight: 500,
      lineHeight: '20px',
    },
    divider: {},
    content: {
      display: 'flex',
      flexDirection: 'column',
    },
    noShadow: {},
    info: {
      alignItems: 'center',
      display: 'inline-flex',
      flex: '0 0 auto',
      marginLeft: spacing(1),
    },
    infoIcon: {
      fontSize: 18,
      marginLeft: 0,
      marginBottom: spacing(1),
    },
    infoTooltip: {
      fontSize: 14,
    },
    accordionIcon: {
      color: colours.neutral[500],
      fontSize: 30,
      marginRight: -spacing(2),
      transform: 'rotate(0deg)',
      transition: 'transform 0.2s ease-in-out',
    },
    accordionIconExpanded: {
      transform: 'rotate(180deg)',
    },
    headerCollapsed: {},

    // Pages with white backgrounds
    [ManageSectionTheme.default]: {
      border: `1px solid ${colours.neutral[200]}`,
      borderRadius: radius.tile,

      '&:not($noShadow)': {
        boxShadow: '0 2px 3px 0 rgba(0, 18, 52, 0.1)',
      },

      '& $header': {
        background: colours.solid.white,
        borderTopLeftRadius: radius.tile,
        borderTopRightRadius: radius.tile,
        padding: spacing(3, 6, 0, 4),
      },

      '& $headerCollapsed': {
        borderBottomLeftRadius: radius.tile,
        borderBottomRightRadius: radius.tile,
        paddingBottom: spacing(3),
      },

      '& $title': {
        color: colours.neutral[900],
      },

      '& $description': {
        color: colours.neutral[400],
      },

      '& $content': {
        borderBottomLeftRadius: radius.tile,
        borderBottomRightRadius: radius.tile,
        backgroundColor: colours.solid.white,
        padding: spacing(6),
      },

      '& $divider': {
        borderBottom: `1px solid ${colours.neutral[200]}`,
        paddingBottom: spacing(3),
      },
    },

    // Overlays with a grey background for steps
    [ManageSectionTheme.grey]: {
      border: `1px solid ${colours.neutral[200]}`,
      borderRadius: radius.tile,

      '&:not($noShadow)': {
        boxShadow: '0 2px 3px 0 rgba(0, 18, 52, 0.1)',
      },

      '& $header': {
        background: '#F6F7F9', //TODO change after creating new palette
        borderTopLeftRadius: radius.tile,
        borderTopRightRadius: radius.tile,
        padding: spacing(3, 6, 0, 4),
      },

      '& $headerCollapsed': {
        borderBottomLeftRadius: radius.tile,
        borderBottomRightRadius: radius.tile,
        paddingBottom: spacing(3),
      },

      '& $title': {
        color: colours.neutral[900],
      },

      '& $description': {
        color: colours.neutral[400],
      },

      '& $content': {
        borderBottomLeftRadius: radius.tile,
        borderBottomRightRadius: radius.tile,
        backgroundColor: '#F6F7F9', //TODO change after creating new palette
        padding: spacing(6),
      },

      '& $divider': {
        borderBottom: `1px solid ${colours.neutral[200]}`,
        paddingBottom: spacing(3),
      },
    },

    // Pages with grey backgrounds
    [ManageSectionTheme.legacy]: {
      border: '1px solid #D1D6DF', //TODO change after creating new palette
      borderRadius: 4,

      '&:not($noShadow)': {
        boxShadow: '0px 4px 8px -2px rgba(16, 24, 40, 0.05), 0px 2px 4px -1px rgba(16, 24, 40, 0.10)',
      },

      '& $header': {
        background: '#FCFCFD', //TODO change after creating new palette
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        padding: spacing(4, 6, 0),
      },

      '& $headerCollapsed': {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        paddingBottom: spacing(4),
      },

      '& $title': {
        color: colors.black.darker,
      },

      '& $description': {
        color: '#9EA6B3', // TODO: Change this after creating new palette
      },

      '& $content': {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        backgroundColor: colours.solid.white,
        padding: spacing(6),
      },

      '& $divider': {
        borderBottom: '1px solid #D1D6DF', //TODO change after creating new palette,
        paddingBottom: spacing(4),
      },
    },
  });
